<ng-container *ngIf="vFormStore$ | async as s">
  <div
    class="v-form-container"
    [ngClass]="{ faded: s.isLoading || s.isSubmitting }"
    *ngIf="formGroup$ | async as f; else loading"
  >
    <form [formGroup]="f" autocomplete="off">
      <div class="v-form" [ngClass]="{ 'compact-form': compact }">
        <ng-container *ngFor="let section of sections$ | async; let len = count">
          <div class="v-form-section">
            <div
              *ngIf="len >= 1 && section.hasVisibleFields() && !!section.label"
              class="section-title"
              [ngStyle]="{ width: fieldWidth }"
            >
              {{ section.label }}
            </div>
            <div *ngIf="len >= 1 && section.hasVisibleFields() && !!section.description" class="section-description">
              {{ section.description }}
            </div>
            <ng-container *ngFor="let field of section.fields">
              @let control = f.controls[field.name];
              <div
                class="v-form-field"
                [ngClass]="['type-' + field.controlType]"
                *ngIf="field && field.visible"
                [ngStyle]="{ 'max-width': fieldWidth, width: fieldWidth }"
              >
                <div class="field">
                  <ng-container [ngSwitch]="field.controlType">
                    <ng-container *ngSwitchCase="controlType.TEXT">
                      @if (control | isFormControl) {
                        <forms-input
                          [style.width]="inputWidth"
                          [placeholder]="field.label"
                          [required]="field.required"
                          [control]="control"
                          [tooltip]="field.tooltip"
                          [name]="field.name"
                        ></forms-input>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.TEXTBOX">
                      @if (control | isFormControl) {
                        <forms-input
                          [style.width]="inputWidth"
                          [placeholder]="field.label"
                          [required]="field.required"
                          [control]="control"
                          [tooltip]="field.tooltip"
                          [name]="field.name"
                        ></forms-input>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.PASSWORD">
                      @if (control | isFormControl) {
                        <forms-input
                          [style.width]="inputWidth"
                          [placeholder]="field.label"
                          [required]="field.required"
                          [control]="control"
                          type="password"
                          [name]="field.name"
                        ></forms-input>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.PHONENUMBER">
                      @if (control | isFormControl) {
                        <forms-phone-number-multi
                          [formControl]="control"
                          [maxMultiples]="field.maxMultiples || 1"
                          [required]="field.required"
                          [placeholder]="field.label"
                        ></forms-phone-number-multi>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.TEXTAREA">
                      @if (control | isFormControl) {
                        <forms-input-textarea
                          [style.width]="inputWidth"
                          [placeholder]="field.label"
                          [required]="field.required"
                          [control]="control"
                        ></forms-input-textarea>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.MULTITEXT">
                      @if (control | isFormArrayControl) {
                        <forms-input-repeated
                          [placeholder]="field.label"
                          [maxFields]="field.maxMultiples"
                          [controlArray]="control"
                        ></forms-input-repeated>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.TOGGLE">
                      @if (control | isFormControl) {
                        <mat-slide-toggle [formControl]="control" [name]="field.name">
                          {{ field.label }}
                        </mat-slide-toggle>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.SWITCH">
                      @if (control | isFormControl) {
                        <mat-slide-toggle [formControl]="control" [name]="field.name">
                          {{ field.label }}
                        </mat-slide-toggle>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.RADIO">
                      @if (control | isFormControl) {
                        <div class="radio-group">
                          <div class="radio-title">{{ field.label }}</div>
                          <mat-radio-group [name]="field.name" [formControl]="control">
                            <mat-radio-button *ngFor="let option of field.options" [value]="option.value">
                              {{ option.label }}
                            </mat-radio-button>
                          </mat-radio-group>
                        </div>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.CHECKBOX">
                      <mat-checkbox
                        color="primary"
                        [checked]="control.value | toBool"
                        [disabled]="control.disabled"
                        (change)="control.setValue($event.checked)"
                      >
                        {{ field.label }}
                      </mat-checkbox>
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.DROPDOWN">
                      @if (control | isFormControl) {
                        <mat-form-field [style.width]="inputWidth">
                          <mat-label *ngIf="field.label && field.label !== 'null'">{{ field.label }}</mat-label>
                          <mat-select
                            [formControl]="control"
                            [required]="field.required"
                            [placeholder]="
                              field.placeholder || (field.label !== 'null' && !!field.label ? field.label : '') || ''
                            "
                          >
                            @for (option of field.options; track option.label) {
                              <mat-option [value]="option.value">
                                {{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint *ngIf="!!field.tooltip" [matTooltip]="field.tooltip">
                            <a (click)="(null)" class="link">
                              {{ 'FRONTEND.FORMS.INPUT.WHATS_THIS' | translate }}
                            </a>
                          </mat-hint>
                        </mat-form-field>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.MULTISELECT">
                      @if (control | isFormControl) {
                        <forms-va-input-tags
                          [style.width]="inputWidth"
                          [options]="field.options"
                          [placeholder]="field.label"
                          [required]="!!field.required"
                          [allowCustomTags]="false"
                          [allowDuplicates]="false"
                          [formControl]="control"
                        ></forms-va-input-tags>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.TAG">
                      @if (control | isFormControl) {
                        <forms-va-input-tags
                          [style.width]="inputWidth"
                          [options]="field.options"
                          [formControl]="control"
                          [allowDuplicates]="field.allowMultiples"
                          [maxFields]="field.maxMultiples"
                          [disabled]="!field.enabled"
                          [required]="!!field.required"
                          [placeholder]="field.placeholder"
                          [allowCustomTags]="field.useSelect2"
                        ></forms-va-input-tags>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.COUNTRYSTATE">
                      @if (control | isFormControl) {
                        <forms-country-state
                          [style.width]="inputWidth"
                          [countries]="field.options.countries"
                          [states]="field.options.states"
                          [required]="!!field.required"
                          [formControl]="control"
                        ></forms-country-state>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.IMAGE">
                      @if ((field | isImageUploadField) && (control | isFormControl)) {
                        <forms-image-uploader
                          [formControl]="control"
                          [customUploader]="field.customMediaUploader"
                          [acceptedMimeTypes]="field.acceptedMimeTypes"
                        ></forms-image-uploader>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.HIDDEN">
                      @if (control | isFormControl) {
                        <forms-input
                          [style.width]="inputWidth"
                          [placeholder]="field.label"
                          [required]="field.required"
                          [control]="control"
                          [style.display]="'none'"
                          [name]="field.name"
                        ></forms-input>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType['TEXT-SEPARATOR']">
                      <div class="text-separator-container" [innerHTML]="field.label"></div>
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.CHECKBOXES">
                      @if (control | isFormArrayControl) {
                        <div class="checkboxes-container">
                          <div class="title">{{ field.label }}</div>
                          <div class="options">
                            @let formArray = control;
                            @for (option of field.options; track option.label) {
                              <mat-checkbox [formControl]="formArray[option.label]" color="primary">
                                {{ option.label }}
                              </mat-checkbox>
                            }
                          </div>
                        </div>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.VSOURCE">
                      <vf-vsource
                        [sourceData]="control"
                        [catalogue]="catalogue$ | async"
                        [enableInternetDataProviders]="field.enableInternetDataProviders"
                        [columns]="field.columns"
                      ></vf-vsource>
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.SEARCH">
                      @if (control | isFormControl) {
                        <forms-input
                          [style.width]="inputWidth"
                          [required]="field.required"
                          [control]="control"
                          [placeholder]="'Search'"
                          [name]="field.name"
                        ></forms-input>
                      }
                    </ng-container>

                    <ng-container *ngSwitchCase="controlType.DATERANGEPICKER">
                      <forms-time-range-selector
                        [style.width]="inputWidth"
                        [ignorePlaceholder]="true"
                        (timeRangeChange)="onTimeRangeChange($event)"
                        (dateRangeChange)="onDateRangeChange($event)"
                        [max]="today"
                        [timeRangeOption]="timeRangeOption"
                        [timeRangeOptions]="timeRangeOptions"
                      ></forms-time-range-selector>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <mat-card appearance="outlined" [style.backgroundColor]="'#ff0000'" [style.color]="'#ffffff'">
                        The control of type {{ field.control }} is not currently supported.
                      </mat-card>
                    </ng-container>
                  </ng-container>

                  <div class="locked" *ngIf="field.locked">
                    <mat-icon>lock</mat-icon>
                    <span class="locked-message" *ngIf="field.lockedMessage">
                      {{ field.lockedMessage }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
      <div class="v-form-buttons">
        <div class="left-buttons">
          <ng-container *ngFor="let button of leftButtons">
            <button
              mat-raised-button
              *ngIf="button.color"
              [color]="button.color"
              [disabled]="button.disableWhenFormInvalidOrLoading ? f.invalid || s.isLoading : false"
              (click)="callButtonAction(button.action, f.getRawValue())"
            >
              {{ button.label }}
            </button>
            <button
              mat-button
              *ngIf="!button.color"
              color="primary"
              [disabled]="button.disableWhenFormInvalidOrLoading ? f.invalid || s.isLoading : false"
              (click)="callButtonAction(button.action, f.getRawValue())"
            >
              {{ button.label }}
            </button>
          </ng-container>
        </div>
        <div class="right-buttons">
          <ng-container *ngIf="rightButtons.length > 0">
            <button mat-icon-button [matMenuTriggerFor]="rightMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #rightMenu>
              <ng-container *ngFor="let button of rightButtons">
                <button mat-menu-item (click)="callButtonAction(button.action, f.getRawValue())">
                  {{ button.label }}
                </button>
              </ng-container>
            </mat-menu>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
</ng-container>
<ng-template #loading>
  <div class="v-form-loading">
    <div class="stencil-shimmer"></div>
    <div class="stencil-shimmer"></div>
    <div class="stencil-shimmer"></div>
  </div>
</ng-template>
